import { createSlice } from "../helper";

const initialState = {
  questions: [],
  currentQuestionIndex: 0,
  answers: {},
  isComplete: false,
  errors: {},
  // Summary state management
  summary: {
    content: '',
    isLoading: false,
    isSaving: false,
    error: null,
    hasChanges: false,
    isContentLoaded: false
  }
};

const mentoringGoalQuestionnaireSlice = createSlice({
  name: "mentoringGoalQuestionnaire",
  initialState,
  reducers: {
    initializeQuestionnaire: (state, action) => {
      const { questions, existingAnswers = {}, existingSummary = '' } = action.payload;
      state.questions = questions;
      state.answers = existingAnswers;
      state.currentQuestionIndex = 0;
      state.summary.content = existingSummary;
      state.summary.hasChanges = false;
    },

    initializeGoalSummary: (state, action) => {
      const { existingSummary = '' } = action.payload;
      state.summary.content = existingSummary;
      state.summary.hasChanges = false;
      state.summary.isContentLoaded = true;
    },

    replaceState: (state, action) => {
      return { ...initialState, ...action.payload };
    },

    goToQuestion: (state, action) => {
      const questionIndex = action.payload.data;
      if (questionIndex >= 0 && questionIndex < state.questions.length) {
        state.currentQuestionIndex = questionIndex;


        // Clear current question errors
        const currentQuestion = state.questions[questionIndex];
        if (currentQuestion && state.errors[currentQuestion.id]) {
          delete state.errors[currentQuestion.id];
        }
      }
    },

    updateAnswer: (state, action) => {
      const { questionId, answer } = action.payload;
      state.answers[questionId] = answer;
      if (state.errors[questionId]) {
        delete state.errors[questionId];
      }
    },

    setValidationError: (state, action) => {
      const { questionId, error } = action.payload;
      state.errors[questionId] = error;
    },

    clearValidationError: (state, action) => {
      const questionId = action.payload;
      delete state.errors[questionId];
    },

    markComplete: (state, _action) => {
      // action.payload is not used but included for updateStore compatibility
      state.isComplete = true;
    },

    setSummaryContent: (state, action) => {
      state.summary = action.payload;
      state.summary.content ||= '';
      state.summary.isLoading = false;
      state.summary.error = null;
      state.summary.isContentLoaded = true;
    },

    updateSummaryContent: (state, action) => {
      state.summary.content = action.payload;
      state.summary.hasChanges = true;
      state.summary.error = null;
    },

    setSummarySaving: (state, action) => {
      state.summary.isSaving = action.payload;
      if (action.payload) {
        state.summary.error = null;
      }
    },

    setSummarySaved: (state) => {
      state.summary.isSaving = false;
      state.summary.hasChanges = false;
      state.summary.error = null;
    },

    setSummaryError: (state, action) => {
      state.summary.error = action.payload;
      state.summary.isLoading = false;
      state.summary.isSaving = false;
    }
  }
});

export const mentoringGoalQuestionnaireActions = mentoringGoalQuestionnaireSlice.actions;

export default mentoringGoalQuestionnaireSlice.reducer;
